import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoArticleInventory} from "./models/DtoArticleInventory";

@Injectable()
export class StockInventoryService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'stock'
    }

    public getInventoryByYear = (year: number): Observable<DtoArticleInventory[]> => {
        return this.http.get<DtoArticleInventory[]>(`${this.apiUrl}/inventory/${year}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/stock/stock-inventory/stock-inventory.service.ts